import { render, staticRenderFns } from "./RequestSampleComponent.html?vue&type=template&id=f6148e22&scoped=true&"
import script from "./RequestSampleComponent.js?vue&type=script&lang=js&"
export * from "./RequestSampleComponent.js?vue&type=script&lang=js&"
import style0 from "./RequestSampleComponent.scss?vue&type=style&index=0&id=f6148e22&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6148e22",
  null
  
)

export default component.exports